module.exports = __webpack_public_path__ + "static/media/COS_LOVREN.4a4f3f4f.webp";